<template>
  <div class="terms-page">
    <div class="terms-container">
      <div class="terms-card">
        <div class="header">
          <h1>{{ $t('userTermsTitle') }}</h1>
          <div class="update-date">{{ $t('lastUpdated') }}{{ $t('updateDate') }}</div>
        </div>

        <div class="content">
          <div class="intro">
            {{ $t('termsIntro') }}
          </div>

          <section class="section" v-for="section in sections" :key="section.id">
            <div class="section-title">{{ section.title }}</div>
            <ol class="section-content">
              <li v-for="(item, index) in section.items" :key="index" class="content-item">
                <span class="text">{{ item.text }}</span>
                
                <div v-if="item.subsections" class="subsection">
                  <div 
                    v-for="(sub, subIndex) in item.subsections" 
                    :key="subIndex" 
                    class="subsection-item"
                  >
                    <span class="subsection-title">{{ sub.title }}</span>
                    {{ sub.text }}
                  </div>
                </div>
              </li>
            </ol>
          </section>
          <div class="button-container">
            <button class="btn block-btn" @click="goToLogin">{{ $t('backToLogin') }}</button>
          </div>
        </div>

        <div class="footer">
          {{ $t('copyright') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserTerms',
  computed: {
    sections() {
      return [
        {
          id: 1,
          title: this.$t('article1Title'),
          items: [
            { text: this.$t('article1Item1') },
            { text: this.$t('article1Item2') },
            { text: this.$t('article1Item3') },
            { text: this.$t('article1Item4') }
          ]
        },
        {
          id: 2,
          title: this.$t('article2Title'),
          items: [
            { text: this.$t('article2Item1') },
            { 
              text: this.$t('article2Item2'),
              subsections: [
                {
                  title: this.$t('article2Sub1Title'),
                  text: this.$t('article2Sub1Text')
                },
                {
                  title: this.$t('article2Sub2Title'),
                  text: this.$t('article2Sub2Text')
                },
                {
                  title: this.$t('article2Sub3Title'),
                  text: this.$t('article2Sub3Text')
                },
                {
                  title: this.$t('article2Sub4Title'),
                  text: this.$t('article2Sub4Text')
                },
                {
                  title: this.$t('article2Sub5Title'),
                  text: this.$t('article2Sub5Text')
                },
                {
                  title: this.$t('article2Sub6Title'),
                  text: this.$t('article2Sub6Text')
                },
                {
                  title: this.$t('article2Sub7Title'),
                  text: this.$t('article2Sub7Text')
                }
              ]
            },
            { text: this.$t('article2Item3') },
            { text: this.$t('article2Item4') },
          ]
        },
        {
          id: 3,
          title: this.$t('article3Title'),
          items: [
            { text: this.$t('article3Item1') },
            { text: this.$t('article3Item2') },
            { text: this.$t('article3Item3') }
          ]
        },
        {
          id: 4,
          title: this.$t('article4Title'),
          items: [
            { text: this.$t('article4Item1') }
          ]
        },
        {
          id: 5,
          title: this.$t('article5Title'),
          items: [
            { text: this.$t('article5Item1') }
          ]
        },
        {
          id: 6,
          title: this.$t('article6Title'),
          items: [
            { text: this.$t('article6Item1') }
          ]
        }
      ]
    }
  },
  methods: {
    goToLogin() {
      // 使用 Vue Router 返回登入頁
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.terms-page {
  min-height: 100vh;
  background: transparent;
  padding: 90px 0 0;
  font-family: "Microsoft JhengHei", "PingFang TC", "Noto Sans TC", sans-serif;
}

.terms-container {
  width: 80vw;
  min-width: 340px;
  margin: 0 auto;
}

.terms-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
}

.header {
  background: transparent;
  padding: 40px 30px;
  text-align: center;
}

.header h1 {
  font-size: 28px;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 1.4;
}

/* 英文時增加字母間距 */
.header h1:lang(en) {
  letter-spacing: 2px;
}

.update-date {
  font-size: 14px;
  opacity: 0.9;
}

.content {
  padding: 40px 30px;
}

.intro {
  padding: 20px;
  border-left: 4px solid transparent;
  margin-bottom: 30px;
  border-radius: 4px;
  line-height: 1.8;
}

.section {
  margin-bottom: 35px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid transparent;
}

.section-content {
  margin-left: 10px;
  padding-left: 20px;
}

.content-item {
  margin-bottom: 15px;
}

.text {
  line-height: 1.8;
}

.subsection {
  margin-left: 20px;
  margin-top: 10px;
}

.subsection-item {
  margin-bottom: 12px;
  padding-left: 15px;
  position: relative;
  line-height: 1.8;
}

.subsection-item::before {
  content: "•";
  position: absolute;
  left: 0;
  font-weight: bold;
}

.subsection-title {
  font-weight: bold;
}

.button-container {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.footer {
  padding: 20px 30px;
  text-align: center;
  font-size: 14px;
  border-top: 1px solid transparent;
}

@media (max-width: 768px) {
  .terms-page {
    padding: 90px 0 0;
  }

  .header {
    padding: 30px 20px;
  }

  .header h1 {
    font-size: 24px;
  }

  .content {
    padding: 30px 20px;
  }

  .section-title {
    font-size: 18px;
  }
}
</style>
